import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user.role === "admin" ? "/admin" : "/portal", { replace: true });
      } catch {
        setError("Google login mislykkedes. Prøv igen.");
        setTimeout(() => navigate("/login", { replace: true }), 1800);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 grain-bg">
      <div className="h-10 w-10 rounded-full border-2 border-blue-600 border-t-transparent animate-spin" />
      <p className="text-slate-600">{error || "Logger dig ind…"}</p>
    </div>
  );
}
